/* eslint-disable one-var */
/* eslint-disable func-names */
/* eslint-disable import/prefer-default-export */
import LStorage from './LStorage'

function createHanlder(lsKey, pk) {
  return {
    set: function (target, key, value, receiver) {
      const item = LStorage.getItem(lsKey)
      if (item && item[pk]) {
        item[pk][key] = value
        LStorage.setItem(lsKey, item)
      }
      return Reflect.set(target, key, value, receiver)
    }
  }
}


function copy(source, keys = []) {
  if (!source) {
    return source
  }
  const d = Object.create(null)
  keys.forEach((k) => {
    d[k] = source[k]
  })
  return d
}


const proxy = function (initState, lsKey, keys = []) {
  const ks = keys,
    obj = Object.assign({}, LStorage.getItem(lsKey), initState)

  // 代理二级属性
  keys.forEach((k) => {
    obj[k] = new Proxy(obj[k], createHanlder(lsKey, k))
  })
  // 存入合并的值
  LStorage.setItem(lsKey, copy(obj, keys))
  return new Proxy(obj, {
    // eslint-disable-next-line func-names
    set: function (target, key, value, receiver) {
      // eslint-disable-next-line no-unused-expressions
      ks.indexOf(key) >= 0 && LStorage.setItem(lsKey, copy(target, keys))
      return Reflect.set(target, key, value, receiver)
    }
  })
}
export {
  proxy
}
